import "core-js/modules/es.array.map.js";
import React from 'react';
import { EUI_THEMES } from '../../../../src/themes'; // @ts-ignore importing from a JS file

import { applyTheme } from '../../services';
var STYLE_STORAGE_KEY = 'js_vs_sass_preference';
var URL_PARAM_KEY = 'themeLanguage';
export var theme_languages = [{
  id: 'language--js',
  label: 'CSS-in-JS',
  title: 'Language selector: CSS-in-JS'
}, {
  id: 'language--sass',
  label: 'Sass',
  title: 'Language selector: Sass'
}];
var THEME_NAMES = EUI_THEMES.map(function (_ref) {
  var value = _ref.value;
  return value;
});
var THEME_LANGS = theme_languages.map(function (_ref2) {
  var id = _ref2.id;
  return id;
});
var defaultState = {
  themeLanguage: THEME_LANGS[0],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeThemeLanguage: function changeThemeLanguage(language) {},
  theme: THEME_NAMES[0],
  changeTheme: function changeTheme(themeValue) {
    applyTheme(themeValue);
  }
};
export var ThemeContext = /*#__PURE__*/React.createContext(defaultState);
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    let theme = localStorage.getItem('theme');
    if (!theme || !THEME_NAMES.includes(theme)) theme = defaultState.theme;
    applyTheme(theme);
    const themeLanguage = this.getThemeLanguage();
    this.state = {
      theme,
      themeLanguage
    };
  }

  changeTheme = themeValue => {
    this.setState({
      theme: themeValue
    }, () => {
      localStorage.setItem('theme', themeValue);
      applyTheme(themeValue);
    });
  };
  getThemeLanguage = () => {
    // Allow theme language to be set by URL param, so we can link people
    // to specific docs, e.g. ?themeLanguage=js, ?themeLanguage=sass
    // Note that because of our hash router, this logic only works on page load/full reload
    const urlParams = window?.location?.href?.split('?')[1]; // Note: we can't use location.search because of our hash router

    const fromUrlParam = new URLSearchParams(urlParams).get(URL_PARAM_KEY); // Otherwise, obtain it from localStorage

    const fromLocalStorage = localStorage.getItem(STYLE_STORAGE_KEY);
    let themeLanguage = fromUrlParam ? `language--${fromUrlParam}` : fromLocalStorage; // If not set by either param or storage, or an invalid value, use the default

    if (!themeLanguage || !THEME_LANGS.includes(themeLanguage)) themeLanguage = defaultState.themeLanguage;
    return themeLanguage;
  };
  setThemeLanguageParam = languageKey => {
    const languageValue = languageKey.replace('language--', ''); // Make our params more succinct

    const hash = window?.location?.hash?.split('?'); // Note: we can't use location.search because of our hash router

    const queryParams = hash[1];
    const params = new URLSearchParams(queryParams);
    params.set(URL_PARAM_KEY, languageValue);
    window.location.hash = `${hash[0]}?${params.toString()}`;
  };
  changeThemeLanguage = language => {
    this.setState({
      themeLanguage: language
    }, () => {
      localStorage.setItem(STYLE_STORAGE_KEY, language);
      this.setThemeLanguageParam(language);
    });
  };

  render() {
    const {
      children
    } = this.props;
    const {
      theme,
      themeLanguage
    } = this.state;
    return <ThemeContext.Provider value={{
      theme,
      themeLanguage,
      changeTheme: this.changeTheme,
      changeThemeLanguage: this.changeThemeLanguage
    }}>
        {children}
      </ThemeContext.Provider>;
  }

}